import React from 'react';
import ImageCarousel from '../components/Home/ImageCarousel';
import AboutSection from '../components/Home/AboutSection';
import ContactForm from '../components/Home/ContactForm';
// Import images with correct paths and names
import ScaleEarings from '../assets/images/scaleEarings.png';
import leafEarrings from '../assets/images/leafEarings.png';
// Use require for the problematic image to bypass TypeScript's strict checking
const multipleEarings = require('../assets/images/multipleEarings.png');

// Sample images for the carousel (replace with actual images later)
const carouselImages = [
  {
    src: ScaleEarings,
    alt: 'Scale Earings'
  },
  {
    src: leafEarrings,
    alt: 'Leaf Earrings'
  },
  {
    src: multipleEarings,
    alt: 'Multiple Earings'
  }
];

const Home: React.FC = () => {
  return (
    <>
      <ImageCarousel images={carouselImages} />
      <AboutSection />
      <ContactForm />
    </>
  );
};

export default Home;
